(function($) {

    var scroll = new SmoothScroll('[href*="#"]:not([data-lity])', {
        speed: 800
    });

})(jQuery);